import React, { useState } from "react";
import {
  FaEnvelope,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaPhoneAlt,
  FaStore,
  FaIdCard,
  FaMapMarkerAlt,
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";
import logonew from "../../assets/images/logonew.jpg";
import api from "../../api";

const SignUp = () => {
  // =========================
  // Form States
  // =========================

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  const [shopName, setShopName] = useState("");
  const [businessType, setBusinessType] = useState("");

  const [identityType, setIdentityType] = useState("gst");
  const [identityNumber, setIdentityNumber] = useState("");

  const [shopAddress, setShopAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pincode, setPincode] = useState("");

  const [checked, setChecked] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  // =========================
  // Error / Success States
  // =========================

  const [error, setError] = useState({});
  const [successMsg, setSuccessMsg] = useState("");

  const navigate = useNavigate();

  const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry",
  ];

  // =========================
  // Email Validation
  // =========================

  const EmailValidation = (email) => {
    return String(email)
      .toLowerCase()
      .match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);
  };

  // =========================
  // Submit Handler
  // =========================

  const handleSignUp = async (e) => {
    e.preventDefault();

    const newError = {};

    // =========================
    // Frontend Validation
    // =========================

    if (!name.trim()) {
      newError.name = "Enter your full name";
    }

    if (!email.trim()) {
      newError.email = "Enter your email";
    } else if (!EmailValidation(email)) {
      newError.email = "Enter a valid email";
    }

    if (!phone.trim()) {
      newError.phone = "Enter your phone number";
    } else if (!/^\d{10}$/.test(phone)) {
      newError.phone = "Enter a valid 10-digit phone number";
    }

    if (!password.trim()) {
      newError.password = "Enter your password";
    } else if (password.length < 6) {
      newError.password = "Password must be at least 6 characters";
    }

    if (!shopName.trim()) {
      newError.shop_name = "Enter your shop name";
    }

    if (!businessType) {
      newError.business_type = "Select your business type";
    }

    if (!identityType) {
      newError.identity_type = "Select identity type";
    }

    if (!identityNumber.trim()) {
      newError.identity_number = "Enter your identity number";
    }

    if (!shopAddress.trim()) {
      newError.shop_address = "Enter your shop address";
    }

    if (!city.trim()) {
      newError.city = "Enter your city";
    }

    if (!state.trim()) {
      newError.state = "Enter your state";
    }

    if (!pincode.trim()) {
      newError.pincode = "Enter your pincode";
    } else if (!/^\d{6}$/.test(pincode)) {
      newError.pincode = "Enter a valid 6-digit pincode";
    }

    if (!checked) {
      newError.terms_accepted =
        "Please agree to the Terms of Service and Privacy Policy";
    }

    setError(newError);

    if (Object.keys(newError).length > 0) {
      return;
    }

    // =========================
    // API Request
    // =========================

    try {
      const res = await api.post("/dealer/register", {
        name,
        email,
        phone,
        password,

        shop_name: shopName,
        business_type: businessType,

        identity_type: identityType,
        identity_number: identityNumber,

        shop_address: shopAddress,
        city,
        state,
        pincode,

        terms_accepted: true,
      });

      if (res.data.status) {
        setSuccessMsg(
          `Hello ${name}, your dealer account has been created successfully! Please login to continue.`
        );

        // Clear form
        setName("");
        setEmail("");
        setPhone("");
        setPassword("");

        setShopName("");
        setBusinessType("");

        setIdentityType("gst");
        setIdentityNumber("");

        setShopAddress("");
        setCity("");
        setState("");
        setPincode("");

        setChecked(false);
        setError({});
      } else {
        setError({
          general: res.data.message || "Registration failed.",
        });
      }
    } catch (err) {
      console.log("Dealer Registration Error:", err);

      const apiErrors = err?.response?.data?.error_message;

      if (apiErrors) {
        const formattedErrors = {};

        Object.keys(apiErrors).forEach((key) => {
          formattedErrors[key] = apiErrors[key][0];
        });

        setError(formattedErrors);
      } else {
        setError({
          general:
            err?.response?.data?.message ||
            err.message ||
            "Registration failed.",
        });
      }
    }
  };

  return (
    <>
      <div className="min-h-screen bg-white">

        <div className="flex flex-col lg:flex-row min-h-screen">

          {/* ================= LEFT BANNER ================= */}

          <div className="relative lg:w-1/3 bg-black overflow-hidden">

            <img
              src={logonew}
              alt="Dealer Signup Banner"
              className="absolute inset-0 w-full h-full object-cover opacity-60"
            />

            <div className="absolute inset-0 bg-gradient-to-r from-black/90 to-black/40"></div>

            <div className="relative z-10 flex flex-col h-full px-8 md:px-16 py-16 text-white">

              <p className="uppercase tracking-[8px] text-[#C79D17] text-sm md:text-lg mb-4">
                JOIN BLACK HEWZEN
              </p>

              <h1 className="text-5xl md:text-7xl font-bold mb-4">
                Dealer
              </h1>

              <div className="w-20 h-[2px] bg-[#C79D17] mb-6"></div>

              <p className="text-lg md:text-2xl leading-relaxed max-w-md">
                Create your dealer account and
                <br />
                unlock our bulk ordering experience.
              </p>

            </div>
          </div>

          {/* ================= RIGHT FORM ================= */}

          <div className="lg:w-1/2 flex items-center justify-center px-6 py-12 bg-white">

            {successMsg ? (

              /* ================= SUCCESS ================= */

              <div className="w-full max-w-xl text-center">

                <h2 className="text-4xl font-serif mb-6">
                  Registration Successful
                </h2>

                <p className="text-green-600 text-lg mb-8">
                  {successMsg}
                </p>

                <button
                  onClick={() => navigate("/dealer/login")}
                  className="w-full h-14 rounded-xl bg-black text-[#C79D17] text-lg font-semibold hover:bg-neutral-900 transition"
                >
                  Dealer Login →
                </button>

              </div>

            ) : (

              /* ================= FORM ================= */

              <form
                onSubmit={handleSignUp}
                autoComplete="off"
                className="w-full max-w-xl"
              >

                <h2 className="text-5xl font-serif text-center text-gray-900">
                  Dealer Registration
                </h2>

                <div className="flex justify-center items-center gap-4 mt-4">

                  <div className="w-14 h-px bg-[#C79D17]"></div>

                  <img
                    src={logonew}
                    alt=""
                    className="w-8 h-8 object-contain"
                  />

                  <div className="w-14 h-px bg-[#C79D17]"></div>

                </div>

                <p className="text-center text-gray-500 mt-4 mb-10">
                  Create your dealer account to continue
                </p>

                {/* ================= GENERAL ERROR ================= */}

                {error.general && (
                  <p className="text-red-500 text-center mb-5 font-medium">
                    {error.general}
                  </p>
                )}

                {/* ================= PERSONAL DETAILS ================= */}

                <h3 className="text-xl font-semibold text-gray-900 mb-5">
                  Personal Details
                </h3>

                {/* ================= FULL NAME ================= */}

                <div className="mb-5">

                  <label className="block mb-2 text-gray-700 font-medium">
                    Full Name
                  </label>

                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="John Doe"
                    className="w-full h-14 rounded-xl border border-gray-300 px-5 outline-none focus:border-[#C79D17]"
                  />

                  {error.name && (
                    <p className="text-red-500 text-sm mt-2">
                      {error.name}
                    </p>
                  )}

                </div>

                {/* ================= EMAIL ================= */}

                <div className="mb-5">

                  <label className="block mb-2 text-gray-700 font-medium">
                    Email Address
                  </label>

                  <div className="relative">

                    <FaEnvelope className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-400" />

                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="you@example.com"
                      className="w-full h-14 rounded-xl border border-gray-300 pl-14 pr-5 outline-none focus:border-[#C79D17]"
                    />

                  </div>

                  {error.email && (
                    <p className="text-red-500 text-sm mt-2">
                      {error.email}
                    </p>
                  )}

                </div>

                {/* ================= PHONE ================= */}

                <div className="mb-5">

                  <label className="block mb-2 text-gray-700 font-medium">
                    Phone Number
                  </label>

                  <div className="relative">

                    <FaPhoneAlt className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-400" />

                    <input
                      type="text"
                      value={phone}
                      onChange={(e) =>
                        setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))
                      }
                      placeholder="9876543210"
                      className="w-full h-14 rounded-xl border border-gray-300 pl-14 pr-5 outline-none focus:border-[#C79D17]"
                    />

                  </div>

                  {error.phone && (
                    <p className="text-red-500 text-sm mt-2">
                      {error.phone}
                    </p>
                  )}

                </div>

                {/* ================= PASSWORD ================= */}

                <div className="mb-8">

                  <label className="block mb-2 text-gray-700 font-medium">
                    Password
                  </label>

                  <div className="relative">

                    <FaLock className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-400" />

                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Create password"
                      className="w-full h-14 rounded-xl border border-gray-300 pl-14 pr-14 outline-none focus:border-[#C79D17]"
                    />

                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-5 top-1/2 -translate-y-1/2 text-gray-500"
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>

                  </div>

                  {error.password && (
                    <p className="text-red-500 text-sm mt-2">
                      {error.password}
                    </p>
                  )}

                </div>

                {/* ================= BUSINESS DETAILS ================= */}

                <h3 className="text-xl font-semibold text-gray-900 mb-5">
                  Business Details
                </h3>

                {/* ================= SHOP NAME ================= */}

                <div className="mb-5">

                  <label className="block mb-2 text-gray-700 font-medium">
                    Shop / Business Name
                  </label>

                  <div className="relative">

                    <FaStore className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-400" />

                    <input
                      type="text"
                      value={shopName}
                      onChange={(e) => setShopName(e.target.value)}
                      placeholder="Your Shop Name"
                      className="w-full h-14 rounded-xl border border-gray-300 pl-14 pr-5 outline-none focus:border-[#C79D17]"
                    />

                  </div>

                  {error.shop_name && (
                    <p className="text-red-500 text-sm mt-2">
                      {error.shop_name}
                    </p>
                  )}

                </div>

                {/* ================= BUSINESS TYPE ================= */}

                <div className="mb-8">

                  <label className="block mb-2 text-gray-700 font-medium">
                    Business Type
                  </label>

                  <select
                    value={businessType}
                    onChange={(e) => setBusinessType(e.target.value)}
                    className="w-full h-14 rounded-xl border border-gray-300 px-5 outline-none focus:border-[#C79D17] bg-white"
                  >

                    <option value="">
                      Select Business Type
                    </option>

                    <option value="Retailer">
                      Retailer
                    </option>

                    <option value="Wholesaler">
                      Wholesaler
                    </option>

                    <option value="Distributor">
                      Distributor
                    </option>

                    <option value="Manufacturer">
                      Manufacturer
                    </option>

                    <option value="Other">
                      Other
                    </option>

                  </select>

                  {error.business_type && (
                    <p className="text-red-500 text-sm mt-2">
                      {error.business_type}
                    </p>
                  )}

                </div>

                {/* ================= IDENTITY DETAILS ================= */}

                <h3 className="text-xl font-semibold text-gray-900 mb-5">
                  Identity Details
                </h3>

                {/* ================= IDENTITY TYPE ================= */}

                <div className="mb-5">

                  <label className="block mb-3 text-gray-700 font-medium">
                    Identity Proof
                  </label>

                  <div className="grid grid-cols-3 gap-3">

                    <button
                      type="button"
                      onClick={() => setIdentityType("gst")}
                      className={`h-12 rounded-xl border transition ${identityType === "gst"
                        ? "border-[#C79D17] bg-[#C79D17]/10 text-[#8a6b00]"
                        : "border-gray-300 text-gray-600"
                        }`}
                    >
                      GST
                    </button>

                    <button
                      type="button"
                      onClick={() => setIdentityType("pan")}
                      className={`h-12 rounded-xl border transition ${identityType === "pan"
                        ? "border-[#C79D17] bg-[#C79D17]/10 text-[#8a6b00]"
                        : "border-gray-300 text-gray-600"
                        }`}
                    >
                      PAN
                    </button>

                    <button
                      type="button"
                      onClick={() => setIdentityType("aadhaar")}
                      className={`h-12 rounded-xl border transition ${identityType === "aadhaar"
                        ? "border-[#C79D17] bg-[#C79D17]/10 text-[#8a6b00]"
                        : "border-gray-300 text-gray-600"
                        }`}
                    >
                      Aadhaar
                    </button>

                  </div>

                  {error.identity_type && (
                    <p className="text-red-500 text-sm mt-2">
                      {error.identity_type}
                    </p>
                  )}

                </div>

                {/* ================= IDENTITY NUMBER ================= */}

                <div className="mb-8">

                  <label className="block mb-2 text-gray-700 font-medium">
                    {identityType === "gst"
                      ? "GST Number"
                      : identityType === "pan"
                        ? "PAN Number"
                        : "Aadhaar Number"}
                  </label>

                  <div className="relative">

                    <FaIdCard className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-400" />

                    <input
                      type="text"
                      value={identityNumber}
                      onChange={(e) =>
                        setIdentityNumber(
                          identityType === "aadhaar"
                            ? e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 12)
                            : e.target.value.toUpperCase()
                        )
                      }
                      placeholder={
                        identityType === "gst"
                          ? "22ABCDE1234F1Z5"
                          : identityType === "pan"
                            ? "ABCDE1234F"
                            : "123456789012"
                      }
                      className="w-full h-14 rounded-xl border border-gray-300 pl-14 pr-5 outline-none focus:border-[#C79D17]"
                    />

                  </div>

                  {error.identity_number && (
                    <p className="text-red-500 text-sm mt-2">
                      {error.identity_number}
                    </p>
                  )}

                </div>

                {/* ================= ADDRESS ================= */}

                <h3 className="text-xl font-semibold text-gray-900 mb-5">
                  Shop Address
                </h3>

                {/* ================= SHOP ADDRESS ================= */}

                <div className="mb-5">

                  <label className="block mb-2 text-gray-700 font-medium">
                    Complete Shop Address
                  </label>

                  <div className="relative">

                    <FaMapMarkerAlt className="absolute left-5 top-5 text-gray-400" />

                    <textarea
                      value={shopAddress}
                      onChange={(e) => setShopAddress(e.target.value)}
                      placeholder="Enter your complete shop address"
                      rows="4"
                      className="w-full rounded-xl border border-gray-300 pl-14 pr-5 py-4 outline-none focus:border-[#C79D17] resize-none"
                    />

                  </div>

                  {error.shop_address && (
                    <p className="text-red-500 text-sm mt-2">
                      {error.shop_address}
                    </p>
                  )}

                </div>

                {/* ================= CITY / STATE ================= */}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">

                  <div>

                    <label className="block mb-2 text-gray-700 font-medium">
                      City
                    </label>

                    <input
                      type="text"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      placeholder="Bareilly"
                      className="w-full h-14 rounded-xl border border-gray-300 px-5 outline-none focus:border-[#C79D17]"
                    />

                    {error.city && (
                      <p className="text-red-500 text-sm mt-2">
                        {error.city}
                      </p>
                    )}

                  </div>

                  <div>

                    <label className="block mb-2 text-gray-700 font-medium">
                      State
                    </label>

                    <select
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                      className="w-full h-14 rounded-xl border border-gray-300 px-5 outline-none focus:border-[#C79D17] bg-white"
                    >
                      <option value="">
                        Select State
                      </option>

                      {states.map((stateName) => (
                        <option key={stateName} value={stateName}>
                          {stateName}
                        </option>
                      ))}
                    </select>

                    {error.state && (
                      <p className="text-red-500 text-sm mt-2">
                        {error.state}
                      </p>
                    )}

                  </div>

                </div>

                {/* ================= PINCODE ================= */}

                <div className="mb-8">

                  <label className="block mb-2 text-gray-700 font-medium">
                    Pincode
                  </label>

                  <input
                    type="text"
                    value={pincode}
                    onChange={(e) =>
                      setPincode(
                        e.target.value.replace(/\D/g, "").slice(0, 6)
                      )
                    }
                    placeholder="243001"
                    className="w-full h-14 rounded-xl border border-gray-300 px-5 outline-none focus:border-[#C79D17]"
                  />

                  {error.pincode && (
                    <p className="text-red-500 text-sm mt-2">
                      {error.pincode}
                    </p>
                  )}

                </div>

                {/* ================= TERMS ================= */}

                <div className="flex items-start gap-3 mb-3">

                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                    className="mt-1 w-4 h-4 accent-[#C79D17]"
                  />

                  <p className="text-sm text-gray-600 leading-6">

                    I agree to the{" "}

                    <span className="text-[#C79D17] font-medium cursor-pointer">
                      Terms of Service
                    </span>{" "}

                    and{" "}

                    <span className="text-[#C79D17] font-medium cursor-pointer">
                      Privacy Policy
                    </span>

                  </p>

                </div>

                {error.terms_accepted && (
                  <p className="text-red-500 text-sm mb-5">
                    {error.terms_accepted}
                  </p>
                )}

                {/* ================= CREATE ACCOUNT ================= */}

                <button
                  type="submit"
                  disabled={!checked}
                  className={`w-full h-14 rounded-xl text-xl font-semibold transition ${checked
                    ? "bg-black text-[#C79D17] hover:bg-neutral-900"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                >
                  Create Dealer Account →
                </button>

                {/* ================= LOGIN LINK ================= */}

                <p className="text-center text-gray-600 mt-8">

                  Already have a dealer account?{" "}

                  <span
                    onClick={() => navigate("/dealer/login")}
                    className="text-[#C79D17] font-semibold cursor-pointer hover:underline"
                  >
                    Dealer Sign In
                  </span>

                </p>

              </form>

            )}

          </div>

        </div>

      </div>
    </>
  );
};

export default SignUp;